import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M41.42 11.26c.78.78.78 2.04 0 2.82l-3.66 3.66-7.5-7.5 3.66-3.66a1.99 1.99 0 0 1 2.82 0zM6 34.5V42h7.5l22.12-22.12-7.5-7.5zm26.085-14.62L12.464 39.5H8.5v-3.964l19.62-19.62z" })
});
export default SvgPencil;
